<template>
  <div
    v-if="rating !== null"
    id="main">
    <v-layout>
      <v-flex>
        <div class="title-box">
          <span>Rating</span>
        </div>
      </v-flex>
    </v-layout>
    <v-layout
      class="pa-3"
      align-center
      justify-center>
      <span class="headline">{{ displayRating }}</span>
      <v-icon class="ml-3">star</v-icon>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "rating-frame",
  props: {
    rating: {
      required: true,
      validator: (val) => val === null ||
        typeof val === "number" ||
        typeof val === "string"
    }
  },
  computed: {
    displayRating () {
      if (typeof this.rating === "number") {
        return this.rating;
      } else if (typeof this.rating === "string") {
        return parseFloat(this.rating).toFixed(1);
      }
      return null;
    }
  }
};
</script>

<style scoped>
#main { border: 1px solid #494949; }
.title-box { border-bottom: 1px solid #494949; padding: 0.5rem 1rem; }
</style>



// WEBPACK FOOTER //
// src/components/SharedComponents/RatingFrame.vue